enum DefaultRampUpSettings {
  InitialSendingLimit = 5,
  RampUpPercent = 10,
}

export default DefaultRampUpSettings;
